<template src="./Isi.html" />

<script>
// mixins
import LockScroll from '../../mixins/LockScroll';
import LockBodyScroll from '../../mixins/LockBodyScroll';

// vuex
import { mapState } from 'vuex';

export default {
  name: "Isi",
  data() {
    return {
      isiState: false
    }
  },
  computed: {
    ...mapState(['links'])
  },
  mixins: [LockScroll],
  methods: {
    toggleIsi() {
      this.isiState = !this.isiState;
      if(this.isiState) LockBodyScroll.methods.lockBodyScroll();
      else LockBodyScroll.methods.unLockBodyScroll();
    }
  }
}
</script>

<style scoped src="./Isi.scss" lang="scss" />
